<template>
    <div class="tabs bold">
        <ul class="d-flex justify-content-between px-4">
            <li v-for="tab in newTabs" @click="activateTab(tab)" :class="{'active':tab.active}" v-html="addBadgeToLabel(tab)"></li>
        </ul>

        <div class="box shadowless">
            <event-details :active="newTabs[0].active" :event="event"></event-details>
            <event-extras :active="newTabs[1].active" :event="event"></event-extras>
            <event-notes :active="newTabs[2].active" :event="event"></event-notes>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import EventExtras from './EventExtras'
import EventDetails from './EventDetails'
import EventNotes from './EventNotesTab'

export default {
    props: {
        event: Object
    },
    data() {
        return {
            activeTab: 1,
            newTabs: [
                {
                    label: 'Details',
                    active: true,
                },
                {
                    label: 'Extras',
                    active: false,
                },
                {
                    label: 'Notes',
                    active: false,
                },
            ]
        }
    },
    computed: {
        ...mapGetters([
            'getEventNotes'
        ])
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab;
        },
        activateTab(tab) {
            this.newTabs.map(eachTab => {
                eachTab.active = false
            })
            tab.active = true
        },
        addBadgeToLabel(tab) {
            if (tab.label == 'Notes' && this.getEventNotes.length > 0) {
                return tab.label + '<span class="notesBadge bg-color-6 lightest fs-smallest radius-normal px-1 ml-1">'+this.getEventNotes.length+'</span>'
            }
            return tab.label
        }
    },
    components: {
        EventExtras,
        EventDetails,
        EventNotes,
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';

.tabs {
    > ul {
        font-size: $font-size-small;
        background-color: $lighter;
        color: $dark;
        margin: 0;
        border-top: 1px solid $light;

        > li {
            display:inline-block;
            height: 3rem;
            line-height: 3rem;
            cursor: pointer;

            &.active {
                color: $darker;
                border-bottom: 3px solid $brand;
            }

            .notesBadge{
                position: relative;
                bottom: 5px;
            }
        }
    }

    .event-tab {
        font-size: $font-size-small;
        color: $darker;

        .table {
            th {
                color: $dark;
            }
        }

        .info {
            border-bottom: 1px solid $light;

            > li {
                line-height: 3em;

                > span {
                    display: inline-block;
                    width: 40%;
                    color: $dark;
                }
            }
        }

        .highlights {
            display: flex;
            border-radius: 4px;
            border: 1px solid $medium;

            > div {
                flex: 1;
                padding: 0.5rem 0.75rem;

                &:not(:first-child) {
                    border-left: 1px solid $medium;
                }

                h1 {
                    margin-bottom: 1.5rem;
                }

                .completed {
                    margin-top: 2rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EventTabs.vue?6841a667